import { useMemo } from 'react';

import { PaymentPlanCard } from './PaymentPlanCard';
import { useShowApprovalPlanCard } from './hooks/useShowApprovalPlanCard';
import { PaymentPlanCardTiers } from './types';

export const PaymentCards = () => {
  const showStartupV0 = useShowApprovalPlanCard({
    planType: 'startup_v0',
    checkApproval: false,
  });
  const showStartup = useShowApprovalPlanCard({ planType: 'startup' });
  const showPartner = useShowApprovalPlanCard({ planType: 'partner' });
  const showPremier = useShowApprovalPlanCard({ planType: 'premier' });

  const cardsToShow = useMemo(() => {
    return [
      'developer',
      'plus',
      ...(showStartupV0 ? ['startup_v0'] : []),
      ...(showStartup ? ['startup'] : []),
      ...(showPartner ? ['partner'] : []),
      ...(showPremier ? ['premier'] : []),
      'applyEnterprise',
    ] as PaymentPlanCardTiers[];
  }, [showStartupV0, showStartup, showPartner, showPremier]);

  return (
    <div className="grid auto-cols-[minmax(0,290px)] grid-flow-col gap-[18px]">
      {cardsToShow.map((card) => (
        <PaymentPlanCard key={card} cardPlanType={card} />
      ))}
    </div>
  );
};
